import { render, staticRenderFns } from "./asset-group-boxes.vue?vue&type=template&id=2b91ce45&scoped=true&"
import script from "./asset-group-boxes.vue?vue&type=script&lang=js&"
export * from "./asset-group-boxes.vue?vue&type=script&lang=js&"
import style0 from "./asset-group-boxes.vue?vue&type=style&index=0&id=2b91ce45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b91ce45",
  null
  
)

export default component.exports